"use strict";
exports.__esModule = true;
exports.ActionFooter = void 0;
var tslib_1 = require("tslib");
var styles_1 = require("@material-ui/core/styles");
var react_1 = tslib_1.__importStar(require("react"));
var __1 = require("..");
var Button_1 = require("../Button");
var Icon_1 = require("../Icon");
var Tooltip_1 = require("../Tooltip");
var helpers_1 = require("./helpers");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    bottomBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '1rem 1.5rem',
        boxShadow: "0px 0px 24px rgba(21, 43, 66, 0.12)",
        zIndex: 1,
        marginTop: 'auto'
    },
    noWrap: {
        whiteSpace: 'nowrap'
    },
    warningContent: {
        padding: function (_a) {
            var showFullWarning = _a.showFullWarning;
            return showFullWarning ? '0.5rem' : '0.5rem 0.4rem';
        },
        borderRadius: theme.shape.borderRadius,
        marginRight: '1rem',
        backgroundColor: '#FFF4DF',
        color: theme.palette.warning.contrastText,
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        height: 32
    },
    loadingMessageContent: {
        padding: function (_a) {
            var showFullWarning = _a.showFullWarning;
            return showFullWarning ? '0.5rem' : '0.5rem 0.4rem';
        },
        borderRadius: theme.shape.borderRadius,
        marginRight: '1rem',
        backgroundColor: '#D9F1FC',
        color: theme.palette.warning.contrastText,
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        height: 32
    },
    warningContentText: {
        marginLeft: '0.3rem'
    },
    saveButton: { marginLeft: '0.5rem' },
    tooltip: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.warning.contrastText
    },
    arrow: {
        color: theme.palette.warning.main
    },
    loader: {
        marginRight: 10
    }
}); });
exports.ActionFooter = react_1.memo(function (_a) {
    var disableSaveButton = _a.disableSaveButton, locales = _a.locales, handleClose = _a.handleClose, handleSave = _a.handleSave, unsavedChanges = _a.unsavedChanges, isLoading = _a.isLoading, showDiscard = _a.showDiscard;
    var _b = react_1.useState(undefined), ref = _b[0], setRef = _b[1];
    var isOverflow = helpers_1.useIsOverflow(ref);
    var showFullWarning = !isOverflow;
    var classes = useStyles({ showFullWarning: showFullWarning });
    var disabledSaveButton = react_1.useMemo(function () {
        if (disableSaveButton) {
            return true;
        }
        return !unsavedChanges || isLoading;
    }, [disableSaveButton, unsavedChanges, isLoading]);
    var measureRef = react_1.useCallback(function (node) {
        if (node !== null) {
            setRef(node);
        }
    }, []);
    return (react_1["default"].createElement("div", { className: classes.bottomBar },
        !isLoading && unsavedChanges && locales.warningMessage && (react_1["default"].createElement(WarningTooltip, { title: showFullWarning ? '' : locales.warningMessage },
            react_1["default"].createElement("div", { className: classes.warningContent },
                react_1["default"].createElement(Icon_1.Icon, { color: "secondary", name: "warning" }),
                showFullWarning && (react_1["default"].createElement("span", { className: classes.warningContentText, ref: measureRef }, locales.warningMessage))))),
        showDiscard && isLoading && locales.loadingMessage && (react_1["default"].createElement("div", { className: classes.loadingMessageContent },
            react_1["default"].createElement(Icon_1.Icon, { color: "primary", name: "info" }),
            react_1["default"].createElement("span", { className: classes.warningContentText }, locales.loadingMessage))),
        showDiscard && !isLoading && (react_1["default"].createElement("div", null,
            react_1["default"].createElement(Button_1.Button, { className: classes.noWrap, onClick: handleClose, variant: "outlined" }, locales.discardButtonLabel))),
        react_1["default"].createElement(Tooltip_1.Tooltip, { title: disableSaveButton
                ? locales.disabledSaveButtonMessage
                : unsavedChanges
                    ? ''
                    : locales.noChangesMessage },
            react_1["default"].createElement("div", null,
                react_1["default"].createElement(Button_1.Button, { className: classes.saveButton + " " + classes.noWrap, color: "primary", disabled: disabledSaveButton, onClick: handleSave, variant: "contained" },
                    isLoading && (react_1["default"].createElement(__1.CircularProgress, { classes: { root: classes.loader }, size: 16 })),
                    locales.saveButtonLabel)))));
});
var WarningTooltip = function (props) {
    var classes = useStyles({});
    return (react_1["default"].createElement(Tooltip_1.Tooltip, tslib_1.__assign({}, props, { classes: { arrow: classes.arrow, tooltip: classes.tooltip } })));
};
//# sourceMappingURL=ActionFooter.js.map